export interface WorkspaceData {
  workspaceName: string
  industry: string
  teamSize: string
}

export interface OnboardingState {
  workspace: WorkspaceData
}

export const INDUSTRIES = [
  'SaaS / Software',
  'Financial Services',
  'Healthcare',
  'E-commerce / Retail',
  'Marketing & Advertising',
  'Consulting',
  'Real Estate',
  'Manufacturing',
  'Education',
  'Other',
] as const

export const TEAM_SIZES = [
  'Just me',
  '2–10',
  '11–50',
  '51–200',
  '201–500',
  '500+',
] as const
